<template>
  <!-- <DbTab :tabList="dbList" ></DbTab> -->
  <div class="container-fluid">
    <!-- style="  display: flex;flex-direction: column;min-height: 100vh;"> -->
    <!-- <StrategyGUI></StrategyGUI> -->
    <a href="/StrategyDocs"> 点击查看攻略文档</a>
    <BasicGUI></BasicGUI>
  </div>
</template>

<script>
// import DbTab from './components/DbTab.vue'
// import axios from "axios"
import BasicGUI from './components/BasicGUI.vue'
// import StrategyGUI from './components/StrategyDoc/StrategyGUI.vue';

export default {
  name: 'App',
  components: {
    // DbTab,
    BasicGUI,
    // StrategyGUI,
  },
  data(){
    return{
      // dbList:['bs2','drh'],
      // dbList:[],
    }
  },
  mounted(){
    // console.log(process.env.NODE_ENV)
    // axios.post('/').then((response) => {
      // this.dbList = response.data
    // })
  }
}
</script>

<style>
/* html, body {
  height: 100%;
  margin: 0;
  padding: 0;
}
.container-fluid {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
} */
</style>
